// Google Ads conversion for a lead from the Palmidos site.
//
// Conversion action "Palmidos website lead" (goal: Submit lead form, count:
// One per click, primary) in Ads account 599-846-3839. It is reported straight
// through the gtag already loaded in both [lang] layouts
// (gtag('config','AW-16923196898')). Pushing to the dataLayer alone did not
// reach Google Ads, so the Industries campaign saw no conversions at all.
//
// Call it only after the server accepted the lead. Count is "One", so a lead
// that both fills a form and books a meeting from the same ad click is still
// one conversion. Never pass personal details here.
const LEAD_SEND_TO = 'AW-16923196898/x4FyCMygxZ0dEOL7zYU_';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function reportGoogleAdsLead(): void {
  if (typeof window === 'undefined') return;
  window.gtag?.('event', 'conversion', {
    send_to: LEAD_SEND_TO,
    value: 1.0,
    currency: 'ILS',
  });
}
